import { render, staticRenderFns } from "./RCheckbox.vue?vue&type=template&id=3e347eaf&scoped=true"
import script from "./RCheckbox.vue?vue&type=script&lang=js"
export * from "./RCheckbox.vue?vue&type=script&lang=js"
import style0 from "./RCheckbox.vue?vue&type=style&index=0&id=3e347eaf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e347eaf",
  null
  
)

export default component.exports